import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { RootLayout } from '@/components/layout/root-layout';
import { ErrorPage } from '@/components/error-page';
import { LoginPage, ChangePasswordPage } from '@/modules/auth';
import { CreatorsPage } from '@/modules/creators';
import { ProgressPage, ApproacherStatsPage } from '@/modules/stats';
import { PipelinePage } from '@/modules/pipeline';
import { EarningsPage } from '@/modules/payments';
import { ComunicadosPage } from '@/modules/comunicados';
import { ADMIN_ROUTES, PAYMENTS_ROUTE } from './admin-routes';
import { TeamPage, TeamHubPage, ApproachersPage } from '@/modules/team';
import { FoundersPage, PrepioneersPage } from '@/modules/founders';
import { ProfilePage } from '@/modules/profile';
import { GameRulesPage } from '@/modules/game-rules';
import {
  RegistrationLandingPage,
  FormQuestionsPage,
  TestResultPage,
  SignupFormPage,
  RegistrationGuard,
  LegalPage,
} from '@/modules/registration';
import { BannedDashboard } from '@/components/banned-dashboard';
import { RedemptionRunningScreen } from '@/components/redemption-running-screen';
import { WalletConfigPage } from '@/components/wallet/wallet-config-page';
import {
  PublicHome,
  ProtectedRoute,
  AuthOnlyRoute,
  AdminOrCollectorRoute,
  NavigateCollector,
} from './route-guards';

export const router = createBrowserRouter([
  {
    element: <Outlet />,
    errorElement: <ErrorPage />,
    children: [
      { path: '/', element: <PublicHome /> },
      { path: '/login', element: <LoginPage /> },
      { path: '/change-password', element: <ChangePasswordPage /> },
      { path: '/terms', element: <LegalPage type="terms" /> },
      { path: '/privacy', element: <LegalPage type="privacy" /> },
      // /register/result NOT behind RegistrationGuard — fresh fail leaves
      // a signup_blocks row that would redirect home; gated by useRequireStep.
      { path: '/register/result', element: <TestResultPage /> },
      {
        element: <RegistrationGuard />,
        children: [
          { path: '/register', element: <RegistrationLandingPage /> },
          { path: '/register/test', element: <FormQuestionsPage /> },
          { path: '/register/signup', element: <SignupFormPage /> },
        ],
      },
      {
        element: <AuthOnlyRoute />,
        children: [
          { path: '/banned', element: <BannedDashboard /> },
          { path: '/redemption', element: <RedemptionRunningScreen /> },
          {
            element: <RootLayout />,
            children: [
              { path: 'wallet', element: <WalletConfigPage /> },
              // /team es el hub de roles (DEBOOK-1904): tres cards que
              // llevan a la pantalla de cada rol.
              { path: 'team', element: <TeamHubPage /> },
              { path: 'team/collectors', element: <TeamPage /> },
              { path: 'team/approachers', element: <ApproachersPage /> },
              { path: 'founders', element: <FoundersPage /> },
              { path: 'prepioneers', element: <PrepioneersPage /> },
              { path: 'profile', element: <ProfilePage /> },
              { path: 'game-rules', element: <GameRulesPage /> },
            ],
          },
        ],
      },
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <RootLayout />,
            children: [
              { path: 'creators', element: <CreatorsPage /> },
              { path: 'earnings', element: <EarningsPage /> },
              { path: 'communications', element: <ComunicadosPage /> },
              { path: 'progress', element: <ProgressPage /> },
              {
                path: 'progress/:collectorId',
                element: <AdminOrCollectorRoute />,
                children: [{ index: true, element: <ApproacherStatsPage /> }],
              },
              { path: 'stats', element: <Navigate to="/progress" replace /> },
              { path: 'stats/:collectorId', element: <NavigateCollector /> },
              ADMIN_ROUTES,
              PAYMENTS_ROUTE,
              { path: 'pipeline', element: <PipelinePage /> },
            ],
          },
        ],
      },
    ],
  },
]);
